import { FC } from 'react';
import { EmptyAppState } from 'ui/illustrations';
import { GENERAL_ERROR_CAPTION, GENERAL_ERROR_HEADING, TEST_ID } from './constants';
import {
  CaptionText,
  ErrorTextWrapper,
  FallbackLink,
  GeneralErrorContainer,
  MainText,
} from './Error.styled';

export type ErrorMarkupProps = {
  id?: string;
  /** Error text to display */
  mainText?: string;
  /** Secondary error text to display */
  captionText?: string;
  /** Route to redirect users in case of an error */
  fallbackLinkTo?: string;
  /** Text on the redirect link */
  fallbackLinkToText?: string;
};

export const ErrorMarkup: FC<React.PropsWithChildren<ErrorMarkupProps>> = ({
  id = TEST_ID,
  mainText = GENERAL_ERROR_HEADING,
  captionText = GENERAL_ERROR_CAPTION,
  fallbackLinkTo,
  fallbackLinkToText,
}) => {
  return (
    <GeneralErrorContainer data-testid={id}>
      <EmptyAppState />
      <ErrorTextWrapper>
        <MainText>{mainText}</MainText>
        <CaptionText>{captionText}</CaptionText>
        {fallbackLinkTo && <FallbackLink to={fallbackLinkTo}>{fallbackLinkToText}</FallbackLink>}
      </ErrorTextWrapper>
    </GeneralErrorContainer>
  );
};
